import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';

import { Storage } from '@ionic/storage';

import { InformacionService } from './../../services/informacion.service';
import { ValidarToken } from 'src/app/validators/valida-datos';
import { ToastController } from '@ionic/angular';

@Component({
  selector: 'app-interfas-informacion',
  templateUrl: './interfaz-informacion.component.html',
  styleUrls: ['./interfaz-informacion.component.scss'],
})
export class InterfazInformacionComponent implements OnInit {
  idAdmin: any;
  classUser: any;

  msjEnviado = false;
  mostrarInput = false;

  urlUsada = '';
  preguntaUsuario = '';
  respuestaIA = '';

  isLoading = false;

  urlForm: FormGroup;
  preguntaForm: FormGroup;

  canal: any;
  canalInicial: any;

  constructor(
    private toastController: ToastController,
    private fb: FormBuilder,
    private informacion: InformacionService,
    private storage: Storage
  ) { }

  ngOnInit() {
    this.classUser = new ValidarToken(this.storage);
    this.getCanal();
    this.preguntaForm = this.fb.group({
      pregunta: ['', [Validators.required, Validators.minLength(3)]]
    });

    this.urlForm = this.fb.group({
      url: ['', [Validators.required, Validators.pattern(/^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\/?].*)?$/)]]
    });
  }

  async getCanal() {
    this.canal = await this.storage.get('canal').then();
    this.canalInicial = await this.storage.get('sesionAgente').then();
    // console.log(this.canalInicial, this.canal, 'Canalllllll inicial interfaz');
    this.idAdmin = this.canal.idAdmin_sec;
    this.getURL();
    // this.registrarURL();
  }

  cargarUrl() {
    if (this.urlUsada === '') {
      this.registrarURL();
    } else {
      this.actualizarURL();
    }
  }

  getURL() {
    this.informacion.getURL(this.idAdmin, this.classUser.id, this.classUser.rol, this.classUser.token).subscribe((res: any) => {
      // console.log('console de getUrl', res);
      // console.log('dataURL', this.urlForm.get('url').value);

      if (res.status === 'success') {
        this.urlUsada = res.data.url;
        this.urlForm.get('url').setValue(this.urlUsada);
      }
    });
  }

  registrarURL() {
    const dataURL = { idAdmin: this.idAdmin, url: this.urlForm.get('url').value };

    this.informacion.registrarURL(this.classUser.id, this.classUser.rol, this.classUser.token, dataURL).subscribe((res: any) => {
      // console.log('registrarURL', res);

      if (res.status === 'success') {
        this.ocultarRowInput();
        this.getURL();
        this.presentToast('La URL se ha guardado con exito', 'success');
        // setTimeout(() => window.location.reload(), 1000);
      }
    });
  }

  actualizarURL() {
    const dataURL = { idAdmin: this.idAdmin, url: this.urlForm.get('url').value };

    this.informacion.actualizarURL(this.idAdmin, this.classUser.id, this.classUser.rol, this.classUser.token, dataURL)
      .subscribe((res: any) => {
        // console.log('actualizarURL', res);

        if (res.status === 'success') {
          this.ocultarRowInput();
          this.presentToast('La URL se ha actualizado con exito', 'success');
          // setTimeout(() => window.location.reload(), 1000);
        } else if (this.urlUsada === this.urlForm.get('url').value) {
          this.presentToast('La URL es la misma', 'danger');
        }
      });
  }

  enviar() {
    const pregunta = this.preguntaForm.get('pregunta').value;

    if (pregunta !== '') {
      this.isLoading = true;
      this.msjEnviado = true;
      this.preguntaForm.reset();

      this.preguntaUsuario = pregunta;
      this.realizarPregunta(pregunta);
    }
  }

  realizarPregunta(pregunta) {
    const dataPregunta = { mensaje: pregunta, url: this.urlUsada };

    this.informacion.realizarPregunta(dataPregunta).subscribe((res: any) => {
      // console.log('realizarPregunta', res);

      if (res.status === 'success') {
        this.isLoading = false;
        this.respuestaIA = res.response.answer;
      } else {
        this.isLoading = false;
        this.presentToast('Ocurrio un error al tratar de responder a tu pregunta, intentelo despues', 'danger');
      }
    });
  }

  mostrarRowInput() {
    this.mostrarInput = true;
  }

  ocultarRowInput() {
    if (this.urlUsada === '') {
      this.urlForm.reset();
    }
    this.mostrarInput = false;
  }

  async presentToast(message, color) {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      position: 'bottom',
      color
    });

    await toast.present();
  }

}
